import { createUseStyles } from 'react-jss'

import { black, darkGrey, lightGrey, mediumGrey } from '../const/colors'
import { defaultBorderRadius, transitionShort } from '../const/common'

export const topDrawerPadding = 110
export const bottomDrawerPadding = 120

export const formTitle = {
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 700,
  marginBottom: 24
}

export const formAdditionalElementsStyles = {
  '& .field, & p': {
    marginTop: 16,
    color: darkGrey
  }
}

export const formSection = {
  position: 'relative',
  padding: '14px 20px 18px',
  marginBottom: 16,
  backgroundColor: 'white',
  textAlign: 'left',
  border: {
    style: 'solid',
    width: 1,
    radius: defaultBorderRadius,
    color: lightGrey
  },
  '& .checkbox': {
    marginTop: 16,
    marginLeft: 0
  },
  ...formAdditionalElementsStyles
}

export const formSectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 16
}

export const formFooter = {
  marginTop: 30,
  display: 'flex',
  justifyContent: 'flex-end'
}

export const formLink = {
  color: 'inherit',

  '&:hover': {
    color: black
  }
}

const useStyles = createUseStyles({
  formTitle: {
    extend: formTitle
  },
  formContainer: {
    paddingBottom: bottomDrawerPadding
  },
  formFooter: {
    extend: formFooter
  },
  section: {
    extend: formSection
  },
  sectionTitle: {
    extend: formSectionTitle
  },
  sectionIcon: {
    position: 'absolute',
    right: 14,
    width: 18,
    top: 12,
    fill: mediumGrey,

    '& path': {
      transition: transitionShort
    },
    '&:hover': {
      cursor: 'pointer',

      '& path': {
        fill: darkGrey
      }
    }
  },
  afterFormText: {
    marginTop: 16
  },
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& $sectionTitle': {
      marginBottom: 0
    }
  },
  dateTimeInput: {
    marginTop: 8,
    maxWidth: 216,
    position: 'relative'
  },
  sectionInfoIconWrapper: {
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 24
  },
  sectionInfoStatusRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 16,
    '& > p:first-of-type': {
      margin: 0
    }
  },
  sectionInfoStatusIcon: {
    flexShrink: 0,
    marginRight: 12,
    width: 20,
    height: 20
  },
  sectionPreview: {
    color: darkGrey,
    '& textarea': {
      color: darkGrey,
      padding: 0
    },
    '& > p, & > div': {
      marginTop: '10px',
      lineHeight: 1.3,
      '& span': {
        display: 'inline-block',
        width: '100%'
      }
    }
  },
  previewSectionTitle: {
    marginBottom: 0
  },
  link: {
    extend: formLink
  },
  subSection: {
    marginTop: 24
  },
  checkboxesGrid: {
    display: 'grid',
    gridTemplateColumns: '80px 80px 80px',
    columnGap: 16,
    rowGap: 8,
    marginTop: 8,
    '& .checkbox': {
      marginTop: 0
    }
  },
  radioButtonsContainer: {
    marginTop: 16,
    color: darkGrey,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  }
})

export default useStyles
